import { Component } from "@angular/core"
import { CardMetaComponent } from "../card-meta.component"

@Component({
    selector: "app-ymal-card-meta",
    templateUrl: "./ymal-card-meta.component.html",
    styleUrls: ["./ymal-card-meta.component.scss"],
})
export class YmalCardMetaComponent extends CardMetaComponent {}
